import { Box, Dialog, Typography } from "@material-ui/core";
import React from "react";
import { useMobile } from "../../hooks/mobile";
import Button, { ButtonSize, ButtonType } from "../common/Button";
import Separator from "../common/Separator";

interface Props {
  open: boolean;
  onSave: () => unknown;
  onExit: () => unknown;
  onClose: () => unknown;
}

export default function YouHaveUnsavedChangesDialog({
  open,
  onSave,
  onExit,
  onClose,
}: Props) {
  const isMobile = useMobile();

  return (
    <Dialog open={open} fullScreen={isMobile} onClose={onClose}>
      <Box
        width={isMobile ? "100%" : "524px"}
        display="flex"
        flexDirection="column"
      >
        <Box boxSizing="border-box" pl="24px" pr="24px" pt="16px" pb="16px">
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            You have unsaved changes
          </Typography>
        </Box>
        <Separator />

        <Box p="24px">
          <Typography variant="body1">
            Are you sure you want to exit? If you exit without saving, you will
            lose any unsaved changes.
          </Typography>
        </Box>

        <Separator />

        <Box
          display="flex"
          justifyContent="flex-end"
          pl="24px"
          pr="16px"
          height="74px"
          alignItems="center"
        >
          <Button
            title="EXIT WITHOUT SAVING"
            size={ButtonSize.medium}
            type={ButtonType.secondary}
            onClick={onExit}
            width="233px"
          />
          <Box width="8px" />
          <Button
            title="SAVE CHANGES"
            size={ButtonSize.medium}
            type={ButtonType.primary}
            onClick={onSave}
            width="167px"
          />
        </Box>
      </Box>
    </Dialog>
  );
}
